import { gql } from '@apollo/client';
import { fieldDecimalPlaces } from 'constants/fieldDecimalPlaces';
import { useQuery } from './apollo';

export const FIELD_DECIMAL_PLACES_CONFIG_QUERY = gql`
  query fieldDecimalPlacesConfig {
    fieldDecimalPlacesConfig {
      fieldType
      decimalPlaces
    }
  }
`;

export function useFieldDecimalPlacesConfig() {
  const { data } = useQuery(FIELD_DECIMAL_PLACES_CONFIG_QUERY);

  const cvsChPercent = data?.fieldDecimalPlacesConfig.find(x => x.fieldType === fieldDecimalPlaces.cvsChPercent)?.decimalPlaces;
  const cvsChPercent6 = data?.fieldDecimalPlacesConfig.find(x => x.fieldType === fieldDecimalPlaces.cvsChPercent6)?.decimalPlaces;
  const cvsChAmount = data?.fieldDecimalPlacesConfig.find(x => x.fieldType === fieldDecimalPlaces.cvsChAmount)?.decimalPlaces;
  const cvsChExRate = data?.fieldDecimalPlacesConfig.find(x => x.fieldType === fieldDecimalPlaces.cvsChExRate)?.decimalPlaces;
  const cvsChPrice = data?.fieldDecimalPlacesConfig.find(x => x.fieldType === fieldDecimalPlaces.cvsChPrice)?.decimalPlaces;

  return { cvsChPercent, cvsChPercent6, cvsChAmount, cvsChExRate, cvsChPrice };
}

export default useFieldDecimalPlacesConfig;
